module.exports = __webpack_public_path__ + "static/img/footer_erweima1.9818f60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer_erweima1.png
// module id = mn1S
// module chunks = 22